import classNames from 'classnames';
import {isEmpty} from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import isNumber from 'lodash/isNumber';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsMatchesLineUp} from '../../../../../../actions/entities/statistics/matches';
import Filters from '../../../../../../components/Filters';
import FilterLeague from '../../../../../../components/Filters/League';
import FilterLocation from '../../../../../../components/Filters/Location';
import FilterPeriod from '../../../../../../components/Filters/Period';
import Loader from '../../../../../../components/Loader';
import './index.css';
import {getChampionships} from '../../../../../../actions/entities/championships';
import {
  getChampionshipId,
  getChampionshipName,
} from '../../../../../../helpers/championship';
import getAvailableFlagsButtons from '../../../../../../helpers/getAvailableFlagsButtons';

class StatsMatchesLineUpWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {
      filters: {
        championship: 'ALL',
        period: {end, start},
        league: {nbPlayers: []},
      },
      order: {key: 'percentLinedUp', value: 'desc'},
      isFetching: false,
      highlightRefreshBtn: true,
    };
  }

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  notifyRefresh(value) {
    const {highlightRefreshBtn} = this.state;
    this.setState({
      highlightRefreshBtn: value !== undefined ? value : !highlightRefreshBtn,
    });
  }

  selectOrChangeOrder(key) {
    if (key === this.state.order.key)
      this.setState({
        order: {key, value: this.state.order.value === 'asc' ? 'desc' : 'asc'},
      });
    else {
      const newOrder = {key};
      // The switch is necessary for the default sortOrder each orderType
      switch (key) {
        case 'teamMatches':
          newOrder.value = 'asc';
          break;
        case 'percentTeamWithThisNbOfMatches':
          newOrder.value = 'desc';
          break;
        default:
          newOrder.value = 'desc';
      }
      this.setState({order: newOrder});
    }
  }

  fetchStats() {
    const callBacks = {
      onError: error => {
        this.setState({isFetching: false});
        swal({
          title: `Oops...`,
          type: 'error',
          html:
            `Something went wrong !<br/>${error}<br/>` +
            `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
        });
      },
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: () => {
        this.setState({isFetching: false});
        this.notifyRefresh(false);
      },
    };

    if (!this.state.isFetching) {
      const {period, league} = this.state.filters;
      const payload = {
        endDate: moment(period.end).format('YYYY-MM-DD'),
        startDate: moment(period.start).format('YYYY-MM-DD'),
        divisionSizes: league.nbPlayers,
      };
      this.props.dispatch(fetchStatsMatchesLineUp(payload, callBacks));
    }
  }

  componentDidMount() {
    this.props.dispatch(getChampionships());
  }

  static getALLData(data) {
    const dataValues = Object.values(data);
    const ALLData = cloneDeep(dataValues[0]);
    for (let i = 1; i < dataValues.length; i += 1) {
      const dataToAdd = dataValues[i];

      ALLData.total += dataToAdd.total;

      Object.keys(ALLData.compositions).forEach(key => {
        ALLData.compositions[key].totalCompositions +=
          dataToAdd.compositions[key].totalCompositions;
        ALLData.compositions[key].wins += dataToAdd.compositions[key].wins;
        ALLData.compositions[key].looses += dataToAdd.compositions[key].looses;
        ALLData.compositions[key].draws += dataToAdd.compositions[key].draws;
      });

      //   Object.keys(ALLData.compositionsUltra).forEach(key => {
      //     ALLData.compositionsUltra[key].totalCompositions +=
      //       dataToAdd.compositionsUltra[key].totalCompositions;
      //     ALLData.compositionsUltra[key].wins +=
      //       dataToAdd.compositionsUltra[key].wins;
      //     ALLData.compositionsUltra[key].looses +=
      //       dataToAdd.compositionsUltra[key].looses;
      //     ALLData.compositionsUltra[key].draws +=
      //       dataToAdd.compositionsUltra[key].draws;
      //   });
    }

    return {...data, 0: ALLData};
  }

  static getPercent(nb, total) {
    const percent = (parseInt(nb, 10) / total) * 100;
    return parseInt(numeral(percent > 100 ? 100 : percent).format('0,0'), 10);
  }

  static formatData(oldData) {
    const newData = {compositions: []};
    if (oldData.compositions) {
      map(oldData.compositions, (data, lineUp) => {
        newData.compositions.push({
          lineUp,
          percentLinedUp: StatsMatchesLineUpWidget.getPercent(
            data.totalCompositions,
            oldData.total,
          ),
          percentWins: StatsMatchesLineUpWidget.getPercent(
            data.wins,
            data.totalCompositions,
          ),
          percentLooses: StatsMatchesLineUpWidget.getPercent(
            data.looses,
            data.totalCompositions,
          ),
          percentDraws: StatsMatchesLineUpWidget.getPercent(
            data.draws,
            data.totalCompositions,
          ),
        });
      });
    }
    // if (oldData.compositionsUltra) {
    //   map(oldData.compositionsUltra, (data, lineUp) => {
    //     newData.compositionsUltra.push({
    //       lineUp,
    //       percentLinedUp: StatsMatchesLineUpWidget.getPercent(
    //         data.totalCompositions,
    //         oldData.totalUltra,
    //       ),
    //       percentWins: StatsMatchesLineUpWidget.getPercent(
    //         data.wins,
    //         data.totalCompositions,
    //       ),
    //       percentLooses: StatsMatchesLineUpWidget.getPercent(
    //         data.looses,
    //         data.totalCompositions,
    //       ),
    //       percentDraws: StatsMatchesLineUpWidget.getPercent(
    //         data.draws,
    //         data.totalCompositions,
    //       ),
    //     });
    //   });
    // }

    return newData;
  }

  renderTables() {
    const flag = c => {
      return this.props.championships[c];
    };

    const {championship} = this.state.filters;
    const {data} = this.props;

    return Object.keys(data).length === 0 ? (
      <p className="text-center px-3 pb-3">No data to show</p>
    ) : (
      <div>
        {map(StatsMatchesLineUpWidget.getALLData(data), (lineUps, c) => {
          return (
            c > 0 &&
            (championship === 'ALL' ||
              getChampionshipId(championship) === flag(Number(c)).mpgId) &&
            this.renderTable(lineUps, Number(c))
          );
        })}
      </div>
    );
  }

  renderTable(lineUps, championship) {
    const cols = {
      lineUp: 'Composition',
      percentLinedUp: '% Lined up',
      percentWins: '% Wins',
      percentLooses: '% Looses',
      percentDraws: '% Draws',
    };
    const {order} = this.state;

    const formatedData = StatsMatchesLineUpWidget.formatData(lineUps);
    return (
      <div>
        <h3 className="px-3">
          {getChampionshipName(championship)} championship
        </h3>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                {this.renderThs(cols)}
                <th>% W + L + D</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th
                  colSpan={Object.keys(cols).length + 1}
                  className="text-center">
                  Classic LineUps
                </th>
              </tr>
              {orderBy(
                formatedData.compositions,
                [order.key],
                [order.value],
              ).map(nb => (
                <tr key={nb.teamMatches}>
                  {map(cols, (value, key) => (
                    <td key={`nb-${nb.teamMatches}-${key}`}>
                      {isNumber(nb[key])
                        ? numeral(nb[key]).format('0,0')
                        : nb[key]}
                      {key.indexOf('percent') > -1 && ' %'}
                    </td>
                  ))}
                  <td>100 %</td>
                </tr>
              ))}
              <tr>
                <td>SUM(LineUps)</td>
                <td>100%</td>
                <td colSpan={Object.keys(cols).length - 1} />
              </tr>
              {/* <tr>
                <th
                  colSpan={Object.keys(cols).length + 1}
                  className="text-center">
                  Ultra LineUps
                </th>
              </tr>
              {orderBy(
                formatedData.compositionsUltra,
                [order.key],
                [order.value],
              ).map(nb => (
                <tr key={nb.teamMatches}>
                  {map(cols, (value, key) => (
                    <td key={`nb-${nb.teamMatches}-${key}`}>
                      {isNumber(nb[key])
                        ? numeral(nb[key]).format('0,0')
                        : nb[key]}
                      {key.indexOf('percent') > -1 && ' %'}
                    </td>
                  ))}
                  <td>100 %</td>
                </tr>
              ))}
              <tr>
                <td>SUM(LineUps)</td>
                <td>100%</td>
                <td colSpan={Object.keys(cols).length - 1} />
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderThs(cols) {
    const {order} = this.state;
    return map(cols, (value, key) => (
      <th key={key}>
        <span
          onClick={() => this.selectOrChangeOrder(key)}
          className={classNames('orderBtn', {
            'text-primary': order.key === key,
          })}>
          {value}&nbsp;
          <i
            className={classNames('fa', {
              'fa-sort': order.key !== key,
              [`fa-sort-${order.value}`]: order.key === key,
            })}
          />
        </span>
      </th>
    ));
  }

  render() {
    const {isFetching, highlightRefreshBtn} = this.state;
    const {championships} = this.props;
    if (isEmpty(championships)) {
      return <></>;
    }

    return (
      <div id="stats-matches-lineUp-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-line-chart" />
              {` LineUps frequency and efficiency`}
            </h3>
          </div>
          <div className="box-body">
            <div className="margin-bottom">
              <Filters>
                <FilterLocation
                  label="Championship:"
                  availableButtons={getAvailableFlagsButtons(
                    this.props.championships,
                  )}
                  onChange={championship => this.updateFilters({championship})}
                  initialValue={this.state.filters.championship}
                />
                <FilterLeague
                  label="Leagues:"
                  onChange={league => {
                    this.updateFilters({league});
                    this.notifyRefresh(true);
                  }}
                  initialValues={this.state.filters.league}
                />
                <FilterPeriod
                  label="Date range:"
                  onChange={period => {
                    this.updateFilters({period});
                    this.notifyRefresh(true);
                  }}
                  buttonGroup={{
                    icon: 'fa fa-refresh',
                    type: highlightRefreshBtn ? 'success' : 'default',
                    onClick: this.fetchStats.bind(this),
                  }}
                  initialValues={this.state.filters.period}
                />
              </Filters>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderTables()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics, championships} = state.app;
    return {
      data: statistics.matches.lineUp,
      championships: championships.list.data,
    };
  },
  dispatch => ({dispatch}),
)(StatsMatchesLineUpWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Matches/LineUp/index.js